import React from 'react';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Showcase } from './components/Showcase';
import { WhyDifferent } from './components/WhyDifferent';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Trust } from './components/Trust';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-[#FAFAF7] font-sans selection:bg-[#D4A574] selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Benefits data-id="element-2" />
      <Showcase data-id="element-3" />
      <WhyDifferent data-id="element-4" />
      <Gallery data-id="element-5" />
      <Reviews data-id="element-6" />
      <Offer data-id="element-7" />
      <FAQ data-id="element-8" />
      <Trust data-id="element-9" />
      <Footer data-id="element-10" />
    </main>;
}